import { render, staticRenderFns } from "./drag-table.vue?vue&type=template&id=4b19cff0&scoped=true&"
import script from "./drag-table.vue?vue&type=script&lang=js&"
export * from "./drag-table.vue?vue&type=script&lang=js&"
import style0 from "./drag-table.vue?vue&type=style&index=0&lang=css&"
import style1 from "./drag-table.vue?vue&type=style&index=1&id=4b19cff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19cff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b19cff0')) {
      api.createRecord('4b19cff0', component.options)
    } else {
      api.reload('4b19cff0', component.options)
    }
    module.hot.accept("./drag-table.vue?vue&type=template&id=4b19cff0&scoped=true&", function () {
      api.rerender('4b19cff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/table/drag-table.vue"
export default component.exports